import { CircularProgress, Stack, Typography } from '@mui/material';
import {
  AddOrganisationUser,
  DisplayAlertErrors,
  OrganisationUserList,
} from '@verifime/components';
import tokens from '@verifime/design-tokens';
import { useOrganisationNotificationData } from './hooks';

export default function OrganisationNotification({
  organisationId,
  allowAdd = true,
  successNotificationHandler,
  errorNotificationHandler,
}: Readonly<
  Pick<
    Parameters<typeof useOrganisationNotificationData>[0],
    'successNotificationHandler' | 'errorNotificationHandler'
  > & {
    organisationId: string;
    allowAdd?: boolean;
  }
>) {
  const { notifications, isLoading, error, addRecord, removeRecord } =
    useOrganisationNotificationData({
      organisationId,
      successNotificationHandler,
      errorNotificationHandler,
    });

  return (
    <Stack
      gap={tokens.spacingXs}
      mt={tokens.spacingBase}
      data-testid="organisation-notification"
      data-component="OrganisationNotification"
      aria-busy={isLoading}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <Typography variant="h5">Notification</Typography>
        {allowAdd && <AddOrganisationUser onAddUser={addRecord} />}
      </Stack>
      {isLoading && <CircularProgress size={20} />}
      {error && (
        <DisplayAlertErrors errors={[{ message: 'Failed to load notification preferences.' }]} />
      )}
      {!isLoading && !error && (
        <OrganisationUserList users={notifications} onRemoveUser={removeRecord} />
      )}
    </Stack>
  );
}
